<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros" v-if="Origen==='Finanzas'">
                <div class="col-9 col-sm-9 col-md-6 col-lg-5 col-xl-4">
                    <div class="d-flex">
                        <div>
                            <label for="hotelEmpresas" class="col-form-label text-primary">Razón Social </label>
                        </div>
                        <div>
                            <select @change="Lista()" v-model="ObjAgente.IdAgente" class="ms-3 form-control form-select" name="hotelEmpresas" id="hotelEmpresas">
                                <option :value="0">Todos</option>
                                <option v-for="(item, idx) in ListaAgentes" :value="item.IdAgente" :key="idx">{{ item.RazonSocial }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </template>
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Empresa</th>
                <th v-show="Origen==='Finanzas'" :class="StyleTh">Razón Social</th>
                <th :class="StyleTh">TipoDestino</th>
                <th :class="StyleTh">RFC</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Empresa}}</h6></td>
                    <td v-if="Origen==='Finanzas'" :class="StyleTd">{{ lista.RazonSocial }}</td>
                    <td><p :class="StyleTd">{{lista.TipoDestino}}</p></td>
                    <td><p :class="StyleTd">{{lista.RFC}}</p></td>
					<td class="align-middle text-center">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdDestino" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="19"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :pIdAgente="ObjAgente.IdAgente" :pOrigen="Origen"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/catalogos/cpDestinos/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCpDestinos';

export default {
    name: 'ListaMcp_Destino',
    props: ['sFiltros','pOrigen','pObjEnviado'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Destinos',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Finanzas',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario Destinos",
                ModalNameId: 'ModalForm',
                ModalSize:'lg',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ReturnRoute:'cpDestinos',
            Origen:'',
            segurity: {},
            ObjAgente: {
                IdAgente:0,
            },
            ListaArrayRows: [],               
            ListaAgentes:[],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;
            await this.$http.get("cpDestinosInner",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    IdAgente: this.ObjAgente.IdAgente,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('cpDestinos/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        ConfigOrigen(){
            if(this.Origen === 'HotelEmpresas'){
                this.ConfigList.TitleFirst = this.ObjAgente.NombreComercial;
                this.ConfigList.Title = 'Destinos';
                this.ReturnRoute = 'hotelEmpresa';
            } else if (this.Origen === 'Finanzas'){
                this.ConfigList.TitleFirst = 'Finanzas';
                this.ConfigList.Title = 'Destinos';
                this.ReturnRoute = 'panelSubMenus';
                this.GetComboAgentes();
            }
            this.oBtnSave.Origen = this.Origen;
        },
        async GetComboAgentes(){
            await this.$http.get("agentes",{
                params:{
                    simple: true,
                }
            }).then((res) => {
                this.ListaAgentes = res.data.data;
            }).catch(err=> console.error(err))
        },
        LimpiarObjAgente(){
            this.ObjAgente = {
                IdAgente:0,
                RazonSocial:''
            }
        },
        Regresar(){
            this.$router.push({name:this.ReturnRoute, params:{}});
        },
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objAgente',JSON.stringify(this.pObjEnviado));
        }
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }
        this.Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(this.Origen === 'Finanzas'){
            sessionStorage.removeItem('objAgente')
        }

        this.ObjAgente = JSON.parse(sessionStorage.getItem('objAgente'));
        if(!this.ObjAgente){
            this.LimpiarObjAgente();
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.ConfigOrigen();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
